import {createApp} from 'vue'
import App from './App.vue'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/global.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
import axios from 'axios'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// import '../config/rem.js'

const app = createApp(App);
app.use(router);
app.use(store).use(ElementPlus);
app.use(ElementPlus, { locale: zhCn })
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.productionTip = false
app.config.globalProperties.$axios = axios

//设置一个全局常量
// app.config.globalProperties.url = "http://wsscapi.sceeic.cn/api/Book";
app.mount('#app');



